/**
 * Repo-slug helpers shared by {@link AgentRepoChip}, the host app's repo
 * labels, and agent search. Kept in their own module so exporting them
 * alongside a component doesn't trip `react-refresh/only-export-components`.
 *
 * `normalizeRepoSlug` itself lives in `@runloop/reflex-contract`: `repoSlug` is
 * a contract field, and the CLI compares it against a blueprint's
 * `metadata.repo` without being able to reach the design system.
 *
 * It is re-exported rather than left for callers to import from the contract
 * because `@reflex/plugin-town` uses it and does not depend on
 * `@runloop/reflex-contract` — routing it through here keeps a dependency out
 * of that plugin, and keeps the existing `@reflex/ui/lib/repo-slug` path
 * working for the other six call sites.
 */
import { normalizeRepoSlug } from '@runloop/reflex-contract';

export { normalizeRepoSlug };

/** Canonical GitHub URL for an `owner/repo` slug (or a value that contains one). */
export function repoUrl(repo: string): string {
  return `https://github.com/${normalizeRepoSlug(repo)}`;
}
